module.exports = "<div [innerHTML]=\"getHtml()\" class=\"article\"></div>\n<div class=\"article-styles\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/article/article.component.html
// module id = 205
// module chunks = 1